module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.79ff7da5.jpg";